let language = lang === null ? 'en' : lang;
$(document).ready(function () {

	// Determine either back button should be present or not
    getUrlParam('backUrl') ? $('.go-back-btn').css('display', 'flex') : 
        $('.go-back-btn').css('display', 'none');

    $('body').show();

    $("#nav-icon1").click(function (e) {
        e.preventDefault();
        $("#wrapper").toggleClass("active");
        $(this).toggleClass('open');

	});

	/**
     * On Go Back Button Click 
     */
    $('.go-back-btn').click(function(e) {
        e.preventDefault();
        // window.open(getUrlParam('backUrl')),"_self";
        window.location.replace(getUrlParam('backUrl'));
    });
	
	/**
     * Toggle fullscreen function who work with webkit and firefox.
    */
	function toggleFullscreen() {

		//var element = document.getElementsByTagName("iframe")[0];
		var element = document.documentElement; 
		
		var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;

		element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
		document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };

		isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
	}

	$('.fullscreen-toggler').click(function() {
		toggleFullscreen();
	});
    
    (function () {

        $('body').show();

        $(".card").on("show.bs.collapse hide.bs.collapse", function (e) {
            if (e.type == 'show') {
                $(this).children('div:first-child').addClass('card-header-white');
            } else {
                $(this).children('div:first-child').removeClass('card-header-white');
            }
        });

    }).call(this);

    if (window.innerWidth < 992) {
        showTab(window.location.hash);
    }

    $(window).resize(function (event) {
        if (window.innerWidth >= 992) {
            $('#ticketsVirtualF').show();
            $('#bettingVirtualF').show();
            $('#slipVitualF').show();
        } else {
            showTab(window.location.hash);
        }
    });

    $('.ui-tabs-tab').click(function () {
        $(this).addClass('ui-tabs-active ui-state-active');
        showTab($(this).find('a').attr('href'));
    });

     $("[data-langName]").map(function(){
        langName = $(this).attr('data-langName');
        $(this).text(langArr[language][langName]);
    });

});

window.redirectToUrl = function(game, terminal = false) {

    window['token'] = getUrlParam('token');
    window['lang'] = getUrlParam('lang') !== null ? getUrlParam('lang') : 'en';
    
    if (!terminal) {
        if (getUrlParam('backUrl')) {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang + '&backUrl=' + getUrlParam('backUrl');
        } else {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang;
        }
    } else {
        window.location.href = game + '/terminal.html?token=' + token + '&lang=' + lang;
    }
}

window.getUrlParam = function(name){
   var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
   if (results==null){
      return null;
   }
   else{
      return decodeURI(results[1]) || 0;
   }
}

window.showTab = function (hash) {

    if ("undefined" === typeof hash || '' == hash) {
        hash = '#betting-tab';
    }

    $('.ui-tabs-tab').removeClass('ui-tabs-active ui-state-active');

    var targetTab = hash.replace('#', '.');

    $(targetTab).addClass('ui-tabs-active ui-state-active');

    switch (hash) {
        case '#betting-tab':
            $('#ticketsVirtualF').hide();
            $('#bettingVirtualF').show();
            $('#slipVitualF').hide();

            break;
        case '#tickets-tab':
            $('#ticketsVirtualF').show();
            $('#bettingVirtualF').hide();
            $('#slipVitualF').hide();

            break;
        case '#statistics-tab':
            $('#ticketsVirtualF').hide();
            $('#bettingVirtualF').hide();
            $('#slipVitualF').show();
            break;
    }

}

window['CalcCombination'] = function(ticketAmount, arr_odds, combDepth) {
	//Broj kvota u nizu
	var itemCount = arr_odds.length;
    
    combDepth = parseInt(combDepth);    
	
	//Ako je broj meceva veci ili jednak broju combDepth
	if (parseInt(itemCount) >= parseInt(combDepth)) { 
		//Racunanje broja kombinacija 
		var n = 1;
		for (var i = (combDepth + 1); i < (itemCount + 1); i++) {
			n = n * i;
		}
	
		var k = 1;
		for (var i = 2; i < (itemCount - combDepth + 1); i++) {
			k = k * i;
		}
	
		var combCount = n / k;
	
		//Racunanje uplate po kombinaciji
		var amountPerComb = ticketAmount / combCount;
	
		//Racunanje maxWin
		var winMoney = 0;
	
		switch(combDepth) {
			case 1:
				for (var m1 = 0; m1 < itemCount; m1++) {
					winMoney = winMoney + amountPerComb * arr_odds[m1];
				}
		        break;
		    case 2:
				for (var m1 = 0; m1 < (itemCount - 1); m1++) {
					for (var m2 = m1 + 1; m2 < itemCount; m2++) {
						winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2];
					}
				}
		        break;
		    case 3:
				for (var m1 = 0; m1 < (itemCount - 2); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 1); m2++) {
						for (var m3 = m2 + 1; m3 < itemCount; m3++) {
							winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3];
						}
					}
				}
		        break;
		    case 4:
				for (var m1 = 0; m1 < (itemCount - 3); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 2); m2++) {
						for (var m3 = m2 + 1; m3 < (itemCount - 1); m3++) {
							for (var m4 = m3 + 1; m4 < itemCount; m4++) {
								winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4];
							}
						}
					}
				}
		        break;
		    case 5:
				for (var m1 = 0; m1 < (itemCount - 4); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 3); m2++) {
						for (var m3 = m2 + 1; m3 < (itemCount - 2); m3++) {
							for (var m4 = m3 + 1; m4 < (itemCount - 1); m4++) {
								for (var m5 = m4 + 1; m5 < itemCount; m5++) {
									winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5];
								}
							}
						}
					}
				}
		        break;
		    case 6:
				for (var m1 = 0; m1 < (itemCount - 5); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 4); m2++) {
						for (var m3 = m2 + 1; m3 < (itemCount - 3); m3++) {
							for (var m4 = m3 + 1; m4 < (itemCount - 2); m4++) {
								for (var m5 = m4 + 1; m5 < (itemCount - 1); m5++) {
									for (var m6 = m5 + 1; m6 < itemCount; m6++) {
										winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6];
									}
								}
							}
						}
					}
				}
		        break;
		    case 7:
				for (var m1 = 0; m1 < (itemCount - 6); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 5); m2++) {
						for (var m3 = m2 + 1; m3 < (itemCount - 4); m3++) {
							for (var m4 = m3 + 1; m4 < (itemCount - 3); m4++) {
								for (var m5 = m4 + 1; m5 < (itemCount - 2); m5++) {
									for (var m6 = m5 + 1; m6 < (itemCount - 1); m6++) {
										for (var m7 = m6 + 1; m7 < itemCount; m7++) {
											winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7];
										}
									}
								}
							}
						}
					}
				}
		        break;
		    case 8:
				for (var m1 = 0; m1 < (itemCount - 7); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 6); m2++) {
						for (var m3 = m2 + 1; m3 < (itemCount - 5); m3++) {
							for (var m4 = m3 + 1; m4 < (itemCount - 4); m4++) {
								for (var m5 = m4 + 1; m5 < (itemCount - 3); m5++) {
									for (var m6 = m5 + 1; m6 < (itemCount - 2); m6++) {
										for (var m7 = m6 + 1; m7 < (itemCount - 1); m7++) {
											for (var m8 = m7 + 1; m8 < itemCount; m8++) {
												winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7] * arr_odds[m8];
											}
										}
									}
								}
							}
						}
					}
				}
		        break;
		    case 9:
				for (var m1 = 0; m1 < (itemCount - 8); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 7); m2++) {
						for (var m3 = m2 + 1; m3 < (itemCount - 6); m3++) {
							for (var m4 = m3 + 1; m4 < (itemCount - 5); m4++) {
								for (var m5 = m4 + 1; m5 < (itemCount - 4); m5++) {
									for (var m6 = m5 + 1; m6 < (itemCount - 3); m6++) {
										for (var m7 = m6 + 1; m7 < (itemCount - 2); m7++) {
											for (var m8 = m7 + 1; m8 < (itemCount - 1); m8++) {
												for (var m9 = m8 + 1; m9 < itemCount; m9++) {
													winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7] * arr_odds[m8] * arr_odds[m9];
												}
											}
										}
									}
								}
							}
						}
					}
				}
		        break;
		    case 10:
				for (var m1 = 0; m1 < (itemCount - 9); m1++) {
					for (var m2 = m1 + 1; m2 < (itemCount - 8); m2++) {
						for (var m3 = m2 + 1; m3 < (itemCount - 7); m3++) {
							for (var m4 = m3 + 1; m4 < (itemCount - 6); m4++) {
								for (var m5 = m4 + 1; m5 < (itemCount - 5); m5++) {
									for (var m6 = m5 + 1; m6 < (itemCount - 4); m6++) {
										for (var m7 = m6 + 1; m7 < (itemCount - 3); m7++) {
											for (var m8 = m7 + 1; m8 < (itemCount - 2); m8++) {
												for (var m9 = m8 + 1; m9 < (itemCount - 1); m9++) {
													for (var m10 = m9 + 1; m10 < itemCount; m10++) {
														winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7] * arr_odds[m8] * arr_odds[m9] * arr_odds[m10];
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
		}

		return winMoney;
	} else {
		return 0;
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/js/script.js
// module id = 1980
// module chunks = 6